import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export const Container = styled.div`
  &.Wrapper{
    display: flex;
    width: 100%;
    flex-direction: column;
    max-height: inherit;
  }
  &.LeftBlock{
    //width: 10%;
  }
  &.Header{
    display: flex;
    align-items: center;
    width: 100%;
    & .PlatformIcon {
      margin-right: 20px;
    }
  }
  &.RightBlock{
    flex: 1;
    overflow: auto;
  }
  &.BottomRightBlock{
    margin-top: 40px;
    overflow: auto;
    white-space: pre-line;
    & img {
      max-width: 100%;
    }
    &.office-365 {
      word-break: break-word;
    }
    & a{
      display: inline-block;
    }
    @media screen and (min-width: 992px) {
      padding-left: 65px;
    }
    & table{
      width: auto!important;
      max-width: 100%!important;
      & td {
        word-break: break-word;
      }
    }
    & pre{
      max-width: 100%!important;
      word-break: break-word;
    }
    &.jira{
      padding-left: 0;
    }
  }
  &.InfoText{
    padding: 5px;
    display: flex;
    &.Matched{
      background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
      //filter: blur(4px);
      margin-left: -5px;
      border-radius: 10px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  &.SlackMessageContainer{
    display: flex;
    flex-direction: column;
    & .MsgInfo{
      max-width: 100%;
    }
  }
  &.TopRightBlock{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
  &.MessageContainer{
    flex: 1;
    width: 70%;
  }
  &.jira-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &.JiraContent{
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    max-height: calc(100% - 125px);
    @media screen and (min-width: 992px) {
      flex-direction: row;
    }
  }
  &.lightBg{
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    padding: 16px;
  }
  &.rightSide{
    width: 360px;
    height: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (min-width: 768px) {
      align-items: flex-end;
      flex-direction: row;
    }
    @media screen and (min-width: 992px) {
      margin-left: 20px;
      margin-top: 0;
      flex-direction: column;
      align-items: stretch;
      //min-height: min-content;
    }
  }
  & .issueDataGrid{
    font-size: 14px;
    font-family: OpenSans, sans-serif;
    display:grid;
    grid-template-columns: max-content auto;
    grid-column-gap:40px;
    grid-row-gap: 10px;
  }
  &.jiraDescription{
    flex: 1;
    word-break: break-word;
    overflow: auto;
  }
`;

export const StyledBtn = styled(Button)`
  &.ResultsModalClose{
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -17px;
    right: -16px;
    border-radius: 100%;
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  }
  &.ModalFooterBtn{
    background: rgb(240, 242, 242);
    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    border-radius: 8px;
    height: 50px;
    position: relative;
  }
  &.Msg{
    width: 162px;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 115%;
    text-align: center;
    color: #0039BB;
  }
`;

export const TitleContainer = styled.div`
  //display: flex;
  //justify-content: space-between;
  overflow: hidden;
  width: 100%;
`

export const StyledModalFooter = styled(Modal.Footer)`
  border-top-width: 0;
  position: relative;
  padding: 10px 25px 25px 10px;
`;

export const StyledImg = styled.img`
  width: 65px;
`;

export const StyledH2 = styled.h2`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  color: #2C2B48;
`;

export const StyledParagraph = styled.p`
  &.Time{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    margin-bottom: 0;
    color: #2C2B48;
    text-align: right;
  }
  &.UserInfo{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 180%;
    color: #2C2B48;
    max-width: 170px;
    //word-break: break-word;
    width: 30%;
    margin-right: 25px;
    margin-bottom: 0;
  }
  &.MsgInfo{
    font-family: OpenSans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 180%;
    color: #2C2B48;
    min-width: 50%;
    max-width: 95%;
    word-break: break-word;
    white-space: pre-line;
    flex: 1;
    margin-bottom: 0;
    
    & a{
      font-size: 20px!important;
      white-space: normal;
    }
  }
  & .code-preview{
    max-width: 100%;
    border: 1px solid #bbb;
    border-radius: 4px;
    font-size: 18px;
    white-space: pre-wrap;
    font-family: monospace;
    padding: 5px 10px;
    background-color: rgb(220,220,221);
  }
  &.jira-title{
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & img{
      margin-right: 5px;
      &.jira-issue-icon{
        height: 24px;
        width: 24px;
      }
    }
  }
  &.font-600{
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 25px;
  }
`;

export const ParagraphMuted = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-size: 14px;
  line-height: 180%;
  color: #4f4f4f;
  font-weight: 400;
  max-width: 90%;
  word-break: break-word;
  &.date{
    font-weight: 400;
    font-size: 12px;
  }
`;

export const StyledModalBody = styled(Modal.Body)`
  padding: 20px 15px;
  max-height: 85vh;
  display: flex;
  //overflow: hidden;
  @media screen and (min-width: 768px) {
    padding: 30px 20px;
  }
  @media screen and (min-width: 992px) {
    padding: 50px 35px 35px 50px;
  }
`;

export const StyledAnchor = styled.a`
  background: rgb(240,242,242);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  backdrop-filter: blur(4px);
  border-radius: 8px;
  height: 50px;
  width: 162px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 115%;
  text-align: center;
  color: #0039BB;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover:not(.Disabled){
    color: #0039BB;
    text-decoration: none;
  }
  &.Disabled{
    background: rgba(240,242,242, .4);
    color: #777;
  }
`;

export const MockAnchor = styled.div`
  background: rgb(240,242,242);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  backdrop-filter: blur(4px);
  border-radius: 8px;
  height: 50px;
  width: 162px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 115%;
  text-align: center;
  color: #0039BB;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover{
    color: #0039BB;
    text-decoration: none;
  }
`

export const SpinnerContainer = styled.div`
  text-align: center;
  margin: 30px 0;
  & .trova-color {
    color: #1C62EF;
  }
`

export const SimpleLink = styled.a`
  color: #0039BB;
  &:hover{
    color: #0039BB;
    text-decoration: none;
  }
`